import { getWithExpiry } from "@/utils/token";
import { X } from "lucide-react";
import { BASE_URL } from "../DetailPageView";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { ModelUserSubscriptionListResponse } from "@models/ModelUserSubscriptionListResponse";

import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

interface ModalInvitationProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  selectedCampaign: ModelUserSubscriptionListResponse;
}

function ModalAttended({
  showModal,
  setShowModal,
  selectedCampaign,
}: ModalInvitationProps) {
  const patchAttended = async () => {
    try {
      const id = getWithExpiry("id");
      const token = getWithExpiry("token");

      const response = await fetch(`${BASE_URL}/user/attended`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          subscription_id: selectedCampaign.id,
          user_id: id,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to patch attended status.");
      }

      return await response.json();
    } catch (err) {
      console.error("Error patching attended:", err);
    }
  };

  const handleAttend = async () => {
    const isConfirmed = window.confirm(
      "업체에서 확인을 눌러 주세요"
    );

    if (!isConfirmed) {
      return;
    }

    try {
      await patchAttended();
      setShowModal(false);
      window.location.reload();
    } catch (error) {
      console.error("Failed to mark attended:", error);
    }
  };

  if (!showModal) return null;

  return (
    <div className="text-center fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md relative">
        <X
          className="absolute right-4 top-4 w-6 h-6 text-gray-800 cursor-pointer"
          onClick={() => setShowModal(false)}
        />
        <h2 className="text-lg font-bold mb-4 mt-4">[ 초대권 ]</h2>
        <hr />
        <p className="text-gray-800 font-semibold mt-6">
          [{selectedCampaign?.nick_name || selectedCampaign?.name}] 님을
          초대합니다.
        </p>
        <div className="py-4">
          {selectedCampaign?.reservation_dtm ? (
            <p className="text-gray-500 mb-4 text-sm">
              예약일시{" "}
              {dayjs(selectedCampaign?.reservation_dtm).format("M월 D일")}{" "}
              {dayjs(
                `${selectedCampaign?.reservation_dtm} ${selectedCampaign?.reservation_time}`
              ).format("A h시 mm분")}
            </p>
          ) : (
            <p className="text-gray-500 mb-4 text-sm">
              사용일자{" "}
              {dayjs(selectedCampaign?.review_start_date, "YY-MM-DD").isValid()
                ? dayjs(selectedCampaign.review_start_date, "YY-MM-DD").format(
                    "YYYY년 M월 D일"
                  )
                : "-"}{" "}
              ~{" "}
              {dayjs(selectedCampaign?.review_end_date, "YY-MM-DD").isValid()
                ? dayjs(selectedCampaign.review_end_date, "YY-MM-DD").format(
                    "YYYY년 M월 D일"
                  )
                : "-"}
            </p>
          )}
        </div>
        <button
          className="px-4 py-3 w-full text-white bg-[#384D92] rounded-full font-semibold"
          onClick={handleAttend}
        >
          초대권 사용
        </button>
      </div>
    </div>
  );
}

export default ModalAttended;
